import { gql } from '@apollo/client';

export const CONFIRM_WIRE_TRANSFER = gql`
  mutation ConfirmWireTransfer($input: ConfirmWireTransferInput!) {
    confirmWireTransfer(input: $input) {
      id
    }
  }
`;
